module.exports = __webpack_public_path__ + "img/groups-lockout-general-group-seating.65094621.jpeg";